import { render, staticRenderFns } from "./clientDetails.vue?vue&type=template&id=c1be197a&scoped=true"
import script from "./clientDetails.vue?vue&type=script&lang=js"
export * from "./clientDetails.vue?vue&type=script&lang=js"
import style0 from "./clientDetails.vue?vue&type=style&index=0&id=c1be197a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1be197a",
  null
  
)

export default component.exports